// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"pea-z"};